export default "__VITE_PUBLIC_ASSET__86829724__"